import {User} from "@irati/types"
import {NewRecognition} from "@irati/recognition/apollo/mutation/Recognition/Create"

export default (user: User, recognition: NewRecognition) => {
  const {userIds} = recognition
  const {teamIds: userTeams = []} = user

  // Cover case where userIds === null
  const userIdList = userIds || []

  const receiversTeams = userIdList
    .map((receiver) => {
      if (receiver.teams?.results) {
        return receiver.teams.results
      }
      return receiver.teams
    })
    .filter((teams) => teams) // filters out null or undefined teams
    .reduce((carry: string[], teams) => [...carry, ...teams.map(({uuid}) => uuid)], [])

  const ids = new Set([...receiversTeams, ...userTeams])

  return ids.size > 0
}
